import { TableContainer } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import { observer } from 'mobx-react-lite';
import React, { useCallback } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import { useCustomStore } from '../../../hooks';
import { SnackBarConfig } from '../../../utils/SnackBarConfig';
import TableBodyContent from './Table/body';
import TableHeader from './Table/header';

type DocumentListProps = {
  sortBY: (src: any) => void;
  storeFilter: any;
  enqueueSnackbar: any;
};

const DocumentsList: React.FC<DocumentListProps> = (
  props: DocumentListProps,
) => {
  const { enqueueSnackbar, sortBY, storeFilter } = props;
  const { documentsStore } = useCustomStore();

  const getMoreList = useCallback(async () => {
    const documentResp = await documentsStore.getDocuments({
      docType: documentsStore.ApiCallType.docType,
      id: documentsStore.ApiCallType.id,
    });
    if (documentResp.isErr()) {
      enqueueSnackbar(String(documentResp.error.message), SnackBarConfig('e'));
    }
  }, [documentsStore, enqueueSnackbar]);

  return (
    <TableContainer sx={{ maxHeight: '82vh' }} id="documents-table">
      <InfiniteScroll
        dataLength={
          documentsStore.DocumentsList && documentsStore.DocumentsList.length
            ? documentsStore.DocumentsList.length
            : 0
        }
        style={{
          overflow: 'unset',
        }}
        next={getMoreList}
        hasMore={documentsStore.HasMoreResults}
        scrollableTarget={'documents-table'}
        loader={
          documentsStore.Loading && (
            <div style={{ textAlign: 'center', width: '100%' }}>
              <CircularProgress
                size={30}
                sx={{ color: '#DEC330', marginBottom: 5, marginTop: 5 }}
              />
            </div>
          )
        }
        endMessage>
        <Table
          sx={{ marginTop: '1rem !important', minWidth: 650 }}
          stickyHeader
          aria-label="sticky table">
          <TableHeader
            {...{
              canShowDriverColumn:
                documentsStore.ApiCallType.docType !== 'driver',
              canShowUnitColumn: documentsStore.ApiCallType.docType !== 'unit',
              sortBY,
              storeFilter,
            }}
          />
          <TableBodyContent />
        </Table>
      </InfiniteScroll>
    </TableContainer>
  );
};
export default observer(DocumentsList);
